import { helper, http, notify } from "../util";

const controller = "Inquiry";

//types
export const RESET_STORE = "RESET_STORE";
export const REQUEST_INQUIRY = "REQUEST_INQUIRY";
export const INIT_INQUIRY = "INIT_INQUIRY";
export const REQUEST_EXTENSIONS_WHITE_LIST = "EXTENSIONS_WHITE_LIST";
export const RECEIVE_EXTENSIONS_WHITE_LIST = "RECEIVE_EXTENSIONS_WHITE_LIST";

//methods
const _resetStore = () => ({ type: RESET_STORE });
export const resetStore = () => (dispatch) => dispatch(_resetStore());

const requestExtensionsWhiteList = () => ({ type: REQUEST_EXTENSIONS_WHITE_LIST })
const receiveExtensionsWhiteList = (payload) => ({ type: RECEIVE_EXTENSIONS_WHITE_LIST, payload })
export const init = () => dispatch => {
    dispatch(requestExtensionsWhiteList());
    return dispatch(() => http.get(helper.getApiPath(controller, 'Init')).then(res => {
        dispatch(receiveExtensionsWhiteList(JSON.parse(res.responseText)))
    }))
}

export const submit = data => dispatch => http.upload(helper.getApiPath(controller, 'Submit'), data);